import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { UserPlus, CheckCircle2, Info } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

export default function Register() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [f, setF] = useState({ name: state?.name || "", phone: "", nik: "", address: "", note: "" });
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/registrations", { ...f, reg_token: state.reg_token });
      setDone(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto min-h-screen bg-white px-6 pt-10 pb-10 sm:shadow-2xl" data-testid="register-page">
      <img src="/brand-banner.webp" alt="Credit Union Tuah Talino - Koperasi Simpan Pinjam" className="h-20 w-auto mx-auto object-contain" data-testid="register-logo" />
      <div className="mt-6 bg-amber-50 border border-amber-200 rounded-2xl p-4 flex gap-3" data-testid="not-registered-message">
        <Info className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
        <p className="text-sm text-slate-800">
          Email <b>{state?.email || "Anda"}</b> belum terdaftar. Untuk dapat masuk ke dashboard anggota, silahkan mendaftar menjadi anggota <b>CU Tuah Talino</b>.
        </p>
      </div>

      {done ? (
        <div className="text-center mt-10" data-testid="register-success">
          <CheckCircle2 className="h-14 w-14 text-emerald-600 mx-auto" />
          <h1 className="text-xl font-bold mt-3">Pendaftaran Terkirim</h1>
          <p className="text-sm text-slate-600 mt-1">Pengurus CU akan meninjau data Anda. Setelah disetujui, Anda akan menerima PIN awal dari admin untuk masuk.</p>
          <button onClick={() => navigate("/")} data-testid="register-back-home" className="mt-6 w-full bg-blue-800 hover:bg-blue-900 text-white font-semibold py-3 rounded-xl">Kembali ke Halaman Masuk</button>
        </div>
      ) : !state?.reg_token ? (
        <button onClick={() => navigate("/")} data-testid="register-login-first" className="mt-6 w-full bg-red-600 text-white font-semibold py-3 rounded-xl">Masuk dengan Google untuk mendaftar</button>
      ) : (
        <form onSubmit={submit} className="mt-6 space-y-3">
          <h1 className="text-xl font-bold flex items-center gap-2"><UserPlus className="h-5 w-5 text-red-600" /> Formulir Pendaftaran Anggota</h1>
          <div><label className="text-sm font-semibold">Nama Lengkap (sesuai KTP)</label><Input required data-testid="register-name" className="mt-1" value={f.name} onChange={set("name")} /></div>
          <div><label className="text-sm font-semibold">NIK</label><Input required inputMode="numeric" data-testid="register-nik" className="mt-1" value={f.nik} onChange={set("nik")} /></div>
          <div><label className="text-sm font-semibold">No. HP / WhatsApp</label><Input required inputMode="tel" data-testid="register-phone" className="mt-1" value={f.phone} onChange={set("phone")} /></div>
          <div><label className="text-sm font-semibold">Alamat</label><Textarea required data-testid="register-address" className="mt-1" value={f.address} onChange={set("address")} /></div>
          <div><label className="text-sm font-semibold">Catatan (opsional)</label><Input data-testid="register-note" className="mt-1" value={f.note} onChange={set("note")} /></div>
          <button type="submit" disabled={busy} data-testid="register-submit" className="w-full bg-red-600 hover:bg-red-700 disabled:opacity-60 text-white font-semibold py-3.5 rounded-xl transition-colors">
            {busy ? "Mengirim..." : "Kirim Pendaftaran"}
          </button>
          <button type="button" onClick={() => navigate("/")} className="w-full text-sm text-slate-500" data-testid="register-cancel">Batal</button>
        </form>
      )}
    </div>
  );
}
